import { routePaths } from '../../routePaths';
import { translate } from '../../utils';
import { RouteType } from '../../types';
import { BackofficePermission } from '../../generated/graphql';
import { BillsIcon } from '../../ui-kit';
import { BillDetailView, Bills } from '../../modules/billManagement';

const BillsRoute: RouteType = {
    exact: true,
    path: routePaths.bills,
    title: translate('Bills'),
    icon: BillsIcon,
    component: Bills,
    permissions: {
        backoffice: [BackofficePermission.HasAccess]
    },
    childrenRoutes: [
        {
            exact: true,
            title: translate('Bill Details'),
            path: routePaths.billsDetail,
            component: BillDetailView,
        }
    ]
};

export default BillsRoute;
